module.exports = __webpack_public_path__ + "img/gerry_anne.6bca1ca8.svg";